module.exports = __webpack_public_path__ + "media/images/covid/banner/sidebar/vi-b1960118bf68049a299cbad9b15133e9.jpg";